var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      attrs: { color: _vm.snackbar.type, timeout: -1 },
      model: {
        value: _vm.snackbar.active,
        callback: function($$v) {
          _vm.$set(_vm.snackbar, "active", $$v)
        },
        expression: "snackbar.active"
      }
    },
    [
      _c("div", { staticStyle: { "text-align": "center", color: "black" } }, [
        _vm._v(_vm._s(_vm.snackbar.message))
      ]),
      _c(
        "div",
        { staticStyle: { "margin-top": "10px", "text-align": "center" } },
        [
          _vm.snackbar.button
            ? _c(
                "v-btn",
                {
                  attrs: { dark: "", variant: "flat", color: "primary" },
                  on: { click: _vm.goToCheckout }
                },
                [_vm._v(" " + _vm._s(_vm.$t("cart.toCheckout")) + " ")]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }